import React, { useState } from 'react';
import api from '../api/api';
import dayjs from 'dayjs';
import { Typography, DatePicker, Table, message, Card } from 'antd';
import RankBadge from '../components/RankBadge';
import helpers from '../utils/helpers';
import columnsFactory from '../utils/columnsFactory';
import { TrophyOutlined } from '@ant-design/icons';
import usePageMeta from '../hooks/usePageMeta';



function Main() {
    const { Title, Text } = Typography;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    usePageMeta('光暈戰記積分排行榜 | 光暈戰記排行榜', 'https://twilightwarscloudflarereact.pages.dev/leaderboard');

    // 設定最早可選擇的日期（數據庫開始日期）
    const minDate = dayjs(helpers.DB_START_DATE);
    const maxDate = dayjs(); // 今天

    const rankRender = (text, record, index) => {
        // compute stable rank based on top_rank_count without mutating data
        const sorted = [...data].sort((a, b) => b.top_rank_count - a.top_rank_count);
        const rank = sorted.findIndex(item => item.userid === record.userid) + 1;
        return <RankBadge rank={rank} />;
    };

    const columns = [
        columnsFactory.makeRankColumn(rankRender),
        columnsFactory.userIdColumn,
        columnsFactory.nicknameColumn,
        columnsFactory.markColumn,
        columnsFactory.addTimeColumn,
    ];

    const fetchDailyData = async (date) => {
        if (!date) {
            message.warning('請選擇日期');
            return;
        }

        setLoading(true);
        try {
            const dateString = date.format('YYYY-MM-DD');
            const response = await api.getDaily(dateString);

            if (response.count === 0) {
                message.info(`${dateString} 沒有找到記錄`);
                setData([]);
            } else {
                message.success(`找到 ${response.count} 筆記錄`);
                const sortedData = response.data.sort((a, b) => a.ranking - b.ranking);
                setData(sortedData);
            }
        } catch (error) {
            console.error('Error fetching daily data:', error);
            message.error('獲取數據失敗');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '1.25rem' }}>
            <Card>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
                    <Title level={2} style={{ margin: 0 }}>
                        <TrophyOutlined style={{ marginRight: '0.5rem', color: '#FFD700' }} />
                        光暈戰記積分排行榜
                    </Title>
                </div>

                <div style={{ marginBottom: '1.25rem' }}>
                    <Text> 📊 數據庫開始日期 2024-08-12 - {dayjs().format('YYYY-MM-DD')}</Text>
                </div>
                <DatePicker
                    style={{ marginBottom: '1.25rem', width: '10rem' }}
                    format="YYYY-MM-DD"
                    placeholder="請選擇日期"
                    inputReadOnly={true}
                    disabledDate={(current) => current < minDate || current > maxDate}
                    onChange={(date) => {
                        fetchDailyData(date);
                    }}
                />
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="ranking"
                    loading={loading}
                    pagination={false}
                    locale={{ emptyText: '暫無數據' }}
                    scroll={{ x: 600 }}
                />
            </Card>
        </div>
    );
}

export default Main;


